import {
  Avatar,
  Box,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Paper,
  Typography,
  Skeleton
} from "@mui/material";
import Masonry from '@mui/lab/Masonry';
import useUserProfile from "../../hooks/useUserProfile.js";
import { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(2),
  '&:hover': {
    boxShadow: theme.shadows[6],
  },
  color: (theme.vars || theme).palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name) {
  return {
    sx: {
      bgcolor: stringToColor(name),
      
    },
    children: `${name.split(' ')[0][0]}`,
  };
}

export default function UserProfileDialog(props) {
  const { handleSelectProfile, loading, profileTypeList} = props;
  // const { getProfile, profileTypeList, loading } = useUserProfile();

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [autoSelected, setAutoSelected] = useState(false);

  const handleListItemClick = (index, data) => {
    setSelectedIndex(index);
    setSelectedProfile(data);
  };

  const renderSkeletonList = () => {
    return [...Array(5)].map((_, index) => (
      <List key={index} sx={{ width: '100%', bgcolor: 'background.paper', p: 0, m: 0 }}>
        <ListItem divider>
          <ListItemAvatar>
            <Skeleton variant="circular" width={40} height={40} />
          </ListItemAvatar>
          <ListItemText
            primary={<Skeleton width="40%" />}
            secondary={<Skeleton width="60%" />}
          />
        </ListItem>
      </List>
    ));
  };

  return (
  <Box sx={{ position: 'relative', height: 340, }}>
    <Box
      sx={{
        height: 'calc(100% - 60px)', 
        overflowY: 'auto',
        pr: 1,
      }}
    >
      <Masonry columns={{ xs: 1, sm: 1 }}>
        {loading
          ? renderSkeletonList()
          : profileTypeList?.map((data, index) => (
              <List key={index} sx={{ width: '100%', bgcolor: 'background.paper', p: 0, m: 0 }}>
                <ListItem
                  divider
                  selected={selectedIndex === index}
                  onClick={() => handleListItemClick(index, data)}
                  sx={{
                    bgcolor: selectedIndex === index ? 'primary.main' : 'background.paper',
                    color: selectedIndex === index ? 'primary.contrastText' : 'text.primary',
                    cursor: 'pointer',
                  }}
                >
                  <ListItemAvatar>
                    <Avatar {...stringAvatar(data.profile_type)} />
                  </ListItemAvatar>
                  <ListItemText
                    primary={<Typography sx={{ fontSize: 12 }}>{data.profile_type}</Typography>}
                    secondary={<Typography sx={{ fontSize: 16, fontWeight: 'bold' }}>{data.role}</Typography>}
                  />
                </ListItem>
              </List>
            ))}
      </Masonry>
    </Box>

    {/* Fixed bottom button */}
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        bgcolor: '#fff',
        p: 1,
        textAlign: 'right',
        borderTop: '1px solid #eee',
      }}
    >
      <Button
        variant="contained"
        color="primary"
        disabled={selectedIndex === null}
        sx={{ textTransform: 'capitalize' }}
        onClick={() => handleSelectProfile(selectedProfile)}
      >
        Select
      </Button>
    </Box>
  </Box>
  );

}
